import * as types from './ActionTypes';
import { getEmoticonsFromServer } from '../utils/ServerManager';

 export function loginSuccess(){
   console.log('loginSuccess Action creator');
   return{
     type:types.LOGIN_SUCCESS
   };
 }

 export function loginFailed(error){
   return{
     type:types.LOGIN_FAILED,
     error
   };
 }

 export function logoutSuccess(){
   console.log('logoutSuccess Action creator');
   return{
     type:types.LOGOUT_SUCCESS
   };
 }

 export function logoutFailed(error){
   return{
     type:types.LOGOUT_FAILED,
     error
   };
 }

 export function signupSuccess(){
   console.log('signupSuccess Action creator');
   return{
     type:types.SIGNUP_SUCCESS
   };
 }

 export function signupFailed(error){
   return{
     type:types.SIGNUP_FAILED,
     error
   };
 }

 export function resetSuccess(){
   console.log('resetSuccess Action creator');
   return{
     type:types.RESET_SUCCESS
   };
 }

 export function resetFailed(error){
   return{
     type:types.RESET_FAILED,
     error
   };
 }
 export function languageChange(language){
   console.log('languagechange action creator');
   return{
     type:types.LANGUAGE_CHANGE,
     language
   };
 }

/* Guide channel test */
 export function emoticonRequest(text) {
   return {
     type: types.EMOTICON_REQUEST,
     payload: {
       text
     }
   }
 }

 export function emoticonSuccess(result) {
   return {
     type: types.EMOTICON_SUCCESS,
     payload: {
       result
     }
   }
 }

 export function emoticonFailure(error) {
   return {
     type: types.EMOTICON_FAILURE,
     error
   }
 }

 export function emoticonCancel() {
   return {
     type: types.EMOTICON_CANCEL
   }
 }

 export function emoticonFetch(text, language) {
   return async dispatch => {
     dispatch(emoticonRequest(text))

     if (!!text) {
       try {
         let responseJson = await getEmoticonsFromServer(text, language)
         console.log(responseJson);
         if (responseJson.info.code === 2000) {
           dispatch(emoticonSuccess(responseJson.result))
         } else {
           dispatch(emoticonFailure(responseJson.info))
         }
       } catch (error) {
         dispatch(emoticonFailure(error))
       }
     } else {
       dispatch(emoticonCancel())
     }

   }
 }
